import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import { CompletionsContext, ThemeContext } from "../App"
import { CheckCircleIcon, ExclamationCircleIcon, MinusCircleIcon, PencilIcon } from "@heroicons/react/24/solid";
import { Label } from "./catalyst-component/fieldset";
import { withTranslation } from "react-i18next";

function verifyPath(json, path) {
  var exists = true;
  if (path) {
    var steps = path.split('.');
    if (steps.length > 1) {
      steps.forEach(step => {
        if (json && json[step]) {
          json = json[step];
        } else {
          exists = false;
        }
      })
    } else {
      if (!json) {
        exists = false;
      }
    }
  } else {
    exists = false;
  }
  return exists;
}

function Recap({ currentStep, setStep, t, readOnly = false, completionToUse = null}) {
  const [completion, setCompletion] = useState({});
  const [completions] = useContext(CompletionsContext);
  const theme = useContext(ThemeContext);
  let { id } = useParams();

  useEffect(() => {
    setCompletion(completionToUse ? {...completionToUse, steps: completionToUse.stepsCandidature} : completions && completions.find(c => c.id === id));
  }, [completions, id, completionToUse])

  function canEditStep(index) {
    if (readOnly) return false;
    if (!completion?.steps) return false;
    for (let i = index + 1; i <= currentStep; i++) {
      if (!completion.steps[i]?.canGoBack) return false;
    }
    return true;
  }

  return completion && <div className="p-3">
    {completion.steps && completion.steps.length > 0 ? completion.steps.filter((s, index) => index < currentStep ? true : false).map((s, index) => {
      var show = false;
      var canEdit = !readOnly && canEditStep(index);
      if (s.questions?.find(q => (((q.fieldType !== "custom input" && q.fieldType !== "custom variable") || (q.fieldType === "custom input" && q.object === "Address") || (q.fieldType === "custom input" && q.object === "Stripe") || (q.fieldType === "custom input" && q.object === "Paybox"))))) { show = true }
      return show && <div className="border border-gray-200 rounded-xl my-3 px-5 py-4 overflow-hidden" key={s.id}>
        <div className="flex justify-between">
          <h2 className="font-medium text-md mb-2">{s.name}</h2>
          {canEdit && <PencilIcon onClick={() => { setStep(index) }} className="cursor-pointer font-bold text-md h-5" style={verifyPath(theme, "secondary_color") ? { color: theme.secondary_color } : null} />}
        </div>
        <div>{s.questions && s.questions.length > 0 ? s.questions.map(q => {
          if (q.subfieldType === "url") {
            return null;
          }
          if ((q.fieldType !== "custom input" && q.fieldType !== "custom variable") || (q.fieldType === "custom input" && q.object === "Address")  || (q.fieldType === "custom input" && q.object === "Stripe") || (q.fieldType === "custom input" && q.object === "Paybox")) {
            var value = "-";
              if (q.value) {
              if (q.fieldType === "file") {
                value = <div className="text-gray-500">{t("File uploaded")}</div>
              } else if (q.fieldType === "custom input" && q.object === "Stripe") {
                value = q.stripe.status === "paid" ? <CheckCircleIcon className="h-5 text-green-500" /> : (q.stripe.status === "waiting" ? <ExclamationCircleIcon className="h-5 text-yellow-500" /> : <MinusCircleIcon className="h-5 text-red-500" />)
              } else if (q.fieldType === "custom input" && q.object === "Paybox") {
                value = q.value === "paid" ? <CheckCircleIcon className="h-5 text-green-500" /> : (q.paybox.status === "waiting" ? <ExclamationCircleIcon className="h-5 text-yellow-500" /> : <MinusCircleIcon className="h-5 text-red-500" />)
              }
              else {
                if (q.fieldType === "select" || q.fieldType === "booleancheckbox" || q.fieldType === "radio") {
                  value = q?.options?.find(opt => opt.value === q.value)?.label
                  // } else if (q.fieldType === "booleancheckbox") {
                  //   value = q.value === "false" || q.value === "Non" || q.value === "False" ? t("No") : t("Yes")
                } else if (q.fieldType === "date") {
                  var d = new Date(q.value);
                  value = (d.getDate() < 10 ? "0" + d.getDate() : d.getDate()) + "/" + (d.getMonth() < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1) + "/" + d.getFullYear();
                } else if (q.fieldType === "checkbox" || q.fieldType === "selectmultiple") {
                  var listValues = q.value.split(";");
                  value = q.options.filter(opt => listValues.includes(opt.value)).map(opt => opt.label).join(", ");
                } else {
                  value = q.value;
                }
              }
            } else if (q.fieldType === "custom input" && q.object === "Address") {
              value = ""
              q.options.forEach(opt => {
                if (!opt.hidden && s.questions.find(q => q.id === opt.value)) {
                  var locq = s.questions.find(q => q.id === opt.value);
                  if (locq.value) {
                    value += locq.value + " "
                  }
                }
              })
            }
            return !q.hidden && <div className="flex justify-between mb-1 text-sm font-medium" key={q.id}>
              <div className="text-gray-400">{q.label}</div>
              <div className="text-gray-500">{value}</div>
            </div>
          } else { return null; }
        }) : null}</div>
      </div>
    }) : null}
  </div>
}

export default withTranslation()(Recap);